const INVALID_CREDIT_ID_MESSAGE =
  "El ID del crédito debe ser un número entero positivo.";

export const normalizeCreditOldId = (oldId) => {
  const value = String(oldId ?? "").trim();

  if (!/^\d+$/.test(value)) {
    return value;
  }

  return value.replace(/^0+(?=\d)/, "");
};

export const isValidCreditOldId = (oldId) => {
  const value = String(oldId ?? "").trim();
  return /^\d+$/.test(value) && !/^0+$/.test(value);
};

export const deployCreditQuotas = async (httpClient, oldId) => {
  if (!isValidCreditOldId(oldId)) {
    throw new Error(INVALID_CREDIT_ID_MESSAGE);
  }

  const normalizedOldId = normalizeCreditOldId(oldId);
  const response = await httpClient.patch(
    `/v1/credits/id/${normalizedOldId}/deploy-quotas`
  );

  return response.data;
};

export const getDeployCreditQuotasErrorMessage = (error) => {
  const status = error?.response?.status;

  if (status === 404) {
    return "No existe un crédito con ese ID.";
  }

  if (status === 409) {
    return "El crédito debe estar en estado PENDING.";
  }

  const message = error?.response?.data?.description;
  const missingDateInputs = [
    "Falta el comercio para calcular la fecha de desembolso.",
    "Falta originDate para calcular la fecha de desembolso.",
  ];

  if (status === 422 && missingDateInputs.includes(message)) {
    return message;
  }

  if (
    status === 500 &&
    message === "No fue posible calcular la fecha de desembolso."
  ) {
    return message;
  }

  return "No fue posible desplegar las cuotas. Intenta nuevamente.";
};
